/* lua.js generated code 0.3.0 */

var bubbles = {
    0: {
        position: [167.7, 116.05],
        scale: 1.5192108154296875,
        rotation: 0,
        firstFrame: 19
    },

    1: {
        position: [149.95, 13.05],
        scale: 2.03411865234375,
        rotation: 0,
        firstFrame: 39
    },

    2: {
        position: [98.45, 83.05],
        scale: 1.8987274169921875,
        rotation: 0,
        firstFrame: 9
    },

    3: {
        position: [111.95, 67.25],
        scale: 1.9654541015625,
        rotation: 0,
        firstFrame: 19
    },

    4: {
        position: [81.45, 73.75],
        scale: 1.39642333984375,
        rotation: 0,
        firstFrame: 6
    },

    5: {
        position: [124.55, 172.45],
        scale: 1.755279541015625,
        rotation: 0,
        firstFrame: 28
    },

    6: {
        position: [147, 107.15],
        scale: 1.899017333984375,
        rotation: 0,
        firstFrame: 34
    },

    7: {
        position: [88.6, 46.35],
        scale: 1.8533172607421875,
        rotation: 0,
        firstFrame: 0
    },

    8: {
        position: [159.7, 2.7],
        scale: 1.799713134765625,
        rotation: 23.947799682617188,
        firstFrame: 4
    },

    9: {
        position: [200.6, 41.9],
        scale: 1.1995849609375,
        rotation: 0,
        firstFrame: 19
    },

    10: {
        position: [165.35, 184.95],
        scale: 1.42938232421875,
        rotation: 0,
        firstFrame: 0
    },

    11: {
        position: [196.7, 90.25],
        scale: 1.8590545654296875,
        rotation: 0,
        firstFrame: 29
    },

    12: {
        position: [219.95, 95.55],
        scale: 1.67626953125,
        rotation: -29.997909545898438,
        firstFrame: 24
    },

    13: {
        position: [156.75, 44.6],
        scale: 1.76397705078125,
        rotation: 0,
        firstFrame: 34
    },

    14: {
        position: [91.15, 131],
        scale: 1.8516845703125,
        rotation: 0,
        firstFrame: 0
    },

    15: {
        position: [152.15, 148.45],
        scale: 1.5914154052734375,
        rotation: 0,
        firstFrame: 0
    },

    16: {
        position: [90.1, 92.4],
        scale: 1.663726806640625,
        rotation: 0,
        firstFrame: 29
    },

    17: {
        position: [147.15, 23.5],
        scale: 1.5087432861328125,
        rotation: 14.999740600585938,
        firstFrame: 18
    },

    18: {
        position: [192.2, 98.3],
        scale: 2.0383453369140625,
        rotation: -30.295364379882812,
        firstFrame: 34
    },

    19: {
        position: [187.3, 133.3],
        scale: 2.010986328125,
        rotation: 0,
        firstFrame: 39
    },

    20: {
        position: [189.25, 69.25],
        scale: 1.57183837890625,
        rotation: 0,
        firstFrame: 39
    },

    21: {
        position: [-18, 78.25],
        scale: 1,
        rotation: 0,
        firstFrame: 0
    },

    22: {
        position: [99.5, 91.25],
        scale: 0.88433837890625,
        rotation: 14.998931884765625,
        firstFrame: 9
    },

    23: {
        position: [161.1, 51.75],
        scale: 1.76397705078125,
        rotation: 0,
        firstFrame: 19
    },

    24: {
        position: [163.55, 128.85],
        scale: 2.03411865234375,
        rotation: 0,
        firstFrame: 21
    },

    25: {
        position: [182.2, 79.8],
        scale: 1.76397705078125,
        rotation: 0,
        firstFrame: 4
    },

    26: {
        position: [154.75, 21.45],
        scale: 1.57183837890625,
        rotation: 0,
        firstFrame: 9
    },

    27: {
        position: [98.25, 97],
        scale: 2.0383453369140625,
        rotation: -30.295364379882812,
        firstFrame: 34
    },

    28: {
        position: [225.55, 77.65],
        scale: 1.1995849609375,
        rotation: 0,
        firstFrame: 19
    }
}
var smallBubbles = {
    0: {
        position: [27.95, 63.75],
        scale: 1,
        rotation: 0,
        firstFrame: 9
    },

    1: {
        position: [-0.45, 43.05],
        scale: 0.731842041015625,
        rotation: 0,
        firstFrame: 14
    },

    2: {
        position: [154.5, 23.85],
        scale: 0.731842041015625,
        rotation: 0,
        firstFrame: 4
    },

    3: {
        position: [129.15, 58.65],
        scale: 0.731842041015625,
        rotation: 0,
        firstFrame: 16
    },

    4: {
        position: [-1.05, 1.55],
        scale: 0.731842041015625,
        rotation: 0,
        firstFrame: 16
    }
}
var HomeSceneAnimBase = require("clover/scene/component/homescene/homeSceneAnim/HomeSceneAnimBase")
var BubbleMaker = xClass("BubbleMaker", HomeSceneAnimBase)
BubbleMaker.prototype.ctor = function () {
    var self = this
    HomeSceneAnimBase.prototype.ctor.call(self)
    var animNode = cc.CSLoader.createNode("cocos/homeAnim_bubblemaker_bubblemaker.csb")
    var animation = cc.CSLoader.createTimeline("cocos/homeAnim_bubblemaker_bubblemaker.csb")
    animNode.runAction(animation)
    animation.gotoFrameAndPlay(0, true)
    self.anim = animation
    animNode.setPosition(-190, 130)
    self.addChild(animNode)
    self.bubbleAnims = table()
    var [OFFSETX, OFFSETY] = [-175, 120]
    for (var k in bubbles) {
        var v = bubbles[k]
        var bubble = cc.CSLoader.createNode("cocos/homeAnim_bubblemaker_bubbleanim.csb")
        var anim = cc.CSLoader.createTimeline("cocos/homeAnim_bubblemaker_bubbleanim.csb")
        bubble.runAction(anim)
        anim.gotoFrameAndPlay(0, 40, v.firstFrame, true)
        anim.setTimeSpeed(0.4)
        bubble.setPosition(OFFSETX + v.position[0], OFFSETY - v.position[1])
        bubble.setScale(v.scale)
        bubble.setRotation(v.rotation)
        self.addChild(bubble)
        table.insert(self.bubbleAnims, anim)
    }
    ;[OFFSETX, OFFSETY] = [-65, 0]
    for (var k in smallBubbles) {
        var v = smallBubbles[k]
        var bubble = cc.CSLoader.createNode("cocos/homeAnim_bubblemaker_bubbleanim2.csb")
        var anim = cc.CSLoader.createTimeline("cocos/homeAnim_bubblemaker_bubbleanim2.csb")
        bubble.runAction(anim)
        anim.gotoFrameAndPlay(1, 40, v.firstFrame, true)
        anim.setTimeSpeed(0.4)
        bubble.setPosition(OFFSETX + v.position[0], OFFSETY - v.position[1])
        bubble.setScale(v.scale)
        bubble.setRotation(v.rotation)
        self.addChild(bubble)
    }
    self.setContentSize(cc.size(200, 200))
}
BubbleMaker.prototype.pause = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.anim.pause()
}
BubbleMaker.prototype.resume = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.anim.resume()
}
BubbleMaker.prototype.onTouched = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    for (var k = 1, v = self.bubbleAnims[1]; v; k++, v = self.bubbleAnims[k]) {
        v.setTimeSpeed(1)
    }
}
BubbleMaker.prototype.onTouchUp = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    for (var k = 1, v = self.bubbleAnims[1]; v; k++, v = self.bubbleAnims[k]) {
        v.setTimeSpeed(0.5)
    }
}
module.exports = BubbleMaker
